import { Helmet } from 'react-helmet-async'

const PageMeta = ({ 
  title = 'RDS Studio | Web Development, Digital Marketing & Automation — SA Boutique Agency',
  description = 'RDS Studio is a South African boutique digital agency specialising in web development, digital marketing, automation and SEO. Serving businesses across SA and internationally. Free consultation.',
  canonical = 'https://rdsstudio.co.za',
  ogImage = 'https://rdsstudio.co.za/images/logo/og-image.png'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Hreflang tags - Self-referencing for South African English */}
      <link rel="alternate" hrefLang="en-ZA" href={canonical} />
      <link rel="alternate" hrefLang="en" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      
      {/* Language and Region */}
      <meta httpEquiv="content-language" content="en-ZA" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="RDS Studio" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_ZA" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@rdsstudio" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}

export default PageMeta
